module.exports = "<div class=\"map-core\" id=\"map-core\"></div>";


//////////////////
// WEBPACK FOOTER
// ./scripts/apps/trips/directives/views/route-map.html
// module id = 595
// module chunks = 0